export default __webpack_public_path__ + "static/media/itas-assicurazioni-de.8c12b878.png";